import { FC, Fragment, useState } from 'react';

import AutTable from '../../../blocks/aut-grid-table';
import PCNLAnomalyForm from '../../../forms/custom-pcnl/pcnlAnomalyForm';
import PCNLAnomalyFormEdit from '../../../forms/custom-pcnl/pcnlAnomalyFormEdit';

import { getPCNLAnomalyTableColumns } from '../../../../utils/data';
import { PCNLAnomalyItem } from '../../../../utils/models';

interface Props {
	nextAnomalyID: number;
	anomalyItems: PCNLAnomalyItem[];
	onDataChange: (items: PCNLAnomalyItem[]) => void;
	onMoveAnomaly: (item: PCNLAnomalyItem) => void;
}

const PCNLAnomaly: FC<Props> = (props) => {
	const [itemToEdit, setItemToEdit] = useState<PCNLAnomalyItem | null>(null);

	const getNewAnomalyID = () => {
		if (props.anomalyItems.length === 0) return props.nextAnomalyID;

		return props.anomalyItems[props.anomalyItems.length - 1].id + 1;
	};

	const handleAddItem = (item: PCNLAnomalyItem) => {
		const newAnomalyItems = [...props.anomalyItems];
		newAnomalyItems.push({ ...item, id: getNewAnomalyID() });

		props.onDataChange(newAnomalyItems);
	};

	const handleDeleteItem = (item: PCNLAnomalyItem): void => {
		const newAnomalyItems = props.anomalyItems.filter((i) => i.id !== item.id);
		props.onDataChange(newAnomalyItems);
	};

	const handleEditItem = (item: PCNLAnomalyItem): void => {
		const index: number = props.anomalyItems.findIndex((r) => r.id === item.id);

		const newAnomalyItems = [...props.anomalyItems];
		newAnomalyItems[index] = { ...newAnomalyItems[index], ...item };

		props.onDataChange(newAnomalyItems);
		setItemToEdit(null);
	};

	const handleCancelEdit = (): void => {
		setItemToEdit(null);
	};

	return (
		<Fragment>
			{itemToEdit ? (
				<PCNLAnomalyFormEdit
					anomalyItem={itemToEdit}
					onEdit={handleEditItem}
					onCancelEdit={handleCancelEdit}
				/>
			) : (
				<PCNLAnomalyForm onAdd={handleAddItem} />
			)}

			<div className="divider my-4"></div>

			<AutTable
				data={props.anomalyItems}
				tableColumns={getPCNLAnomalyTableColumns()}
				onDeleteItem={handleDeleteItem}
				onMoveItem={props.onMoveAnomaly}
				onEditItem={(item: PCNLAnomalyItem) => setItemToEdit(item)}
			/>
		</Fragment>
	);
};

export default PCNLAnomaly;
